import { createContext, useContext, useState, ReactNode } from "react";
import { en } from "./locales/en";
import { zh } from "./locales/zh";
import type { Translations } from "./locales/en";

export type Language = "en" | "zh";

const locales: Record<Language, Translations> = { en, zh };

interface LangContextType {
  lang: Language;
  t: Translations;
  setLang: (l: Language) => void;
}

const LangContext = createContext<LangContextType>({
  lang: "en",
  t: en,
  setLang: () => {},
});

export function LangProvider({ children }: { children: ReactNode }) {
  const [lang, setLangState] = useState<Language>("en");

  const setLang = (l: Language) => {
    setLangState(l);
    document.documentElement.lang = l;
  };

  return (
    <LangContext.Provider value={{ lang, t: locales[lang], setLang }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
